module.exports = __webpack_public_path__ + "media/assets/marker-shadow-a0c6cc14.png";